import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';

@Injectable()
export class AccountSettingsService {
  constructor(
    private httpService: HttpService
    ) {}

  public getSurvays(): Observable<void> {
    return this.httpService.makeGet<void>('getsurveyquestions');
  }
  
  public setSurvayQuestionsAnswers(surveyQuestionAnswers: any): Observable<void> {
    return this.httpService.makePost<any, any>('setsurveyquestionanswers',  {surveyQuestionAnswers: surveyQuestionAnswers.surveyQuestionAnswers});
  }

  public getNotifications(): Observable<void> {
    return this.httpService.makeGet<void>('getaccountnotificationsettings');
  }
  
  public setNotifications(notification: any): Observable<void> {
    return this.httpService.makePost<any, any>('setaccountnotificationpermission',  notification.notifications);
  }
}
